import React from "react";
import "./Lablist.scss";
import http from "../../util/api";
import {Icon,Toast,Modal} from "antd-mobile";
import Loading from "../../components/Loading";
const Antalert = Modal.alert;
const pingFen=['非常推荐','推荐']
const pingFenB=['不推荐','非常不推荐']
const mapping=[
  {
    nameEN:'energy',
    nameCN:'热量'
  },
  {
    nameEN:'water',
    nameCN:'水分'
  },{
    nameEN:'protein',
    nameCN:'蛋白质'
  },
  {
    nameEN:'fat',
    nameCN:'脂肪'
  },
  {
    nameEN:'dietaryFiber',
    nameCN:'膳食纤维'
  },
  {
    nameEN:'carbohydrates',
    nameCN:'碳水化物'
  },
  {
    nameEN:'retinolEquivalent',
    nameCN:'视黄醇当量'
  },
  {
    nameEN:'vb1',
    nameCN:'硫胺素(VB1)'
  },
  {
    nameEN:'vb2',
    nameCN:'硫胺素(VB1)'
  },
  {
    nameEN:'vb1',
    nameCN:'核黄素(VB2)'
  },
  {
    nameEN:'nicotinicAcid',
    nameCN:'尼克酸'
  },
  {
    nameEN:'ca',
    nameCN:'钙'
  },
  {
    nameEN:'fe',
    nameCN:'铁'
  },
  {
    nameEN:'vc',
    nameCN:'抗坏血酸(VC)'
  },
  {
    nameEN:'cholesterol',
    nameCN:'胆固醇'
  }
]
const reco=[1,2,3,4,5,6,7,8,9,10]
class Lablist extends React.Component {
  state = {
    showAll:false,
    wordsList:[],
    isWordsEnd:false,
    curMarkRec:{},
    isNotRec:false,
    loading:true,
    showValue:false,
    animate:true,
    wordsIndex:0,
    showIndex:'?',
    totalFoods:'?',
    recValue:5,
    userData:{
      imgUrl:'',
      rank:'?',
      bonus:'?',
      recTime:0,
      notRecTime:0,
    },
    currentFood:{
      foodName:'',
      foodOrder:'?',
      good:'?',
      notGood:'?',
      imgUrl:'',
      denominatorValue:'?',
      denominatorUnit:'g',
      numeratorUnit:'mg',
    },
    nutritionList:[
    ],
    foodList:[
    ],
    event:[
    ],
    curFoodImgList:[],
    curImgUrl:null,
    enlarge:false
  };
  async componentDidMount() {
    let token=localStorage.getItem('AccessToken');
    if(token){
    this.getUserData();

    }else{
      this.props.history.push('/login');

    }
  }
  showImg=(v)=>{
    this.setState({curImgUrl:v});
  }
  hideImg=(v)=>{
    this.setState({curImgUrl:null});
  }
  delImg=async(k)=>{
    if(k>-1){
      let arr = this.state.curFoodImgList;
      let n=0;
      let fin=[];
      while(n<arr.length){
        if(n!=k){
          fin.push(arr[n])
        }else{
          if(arr[n].REC_ID){
            this.setState({loading:true});
            try{
              let res = await http().removeRecords({
                resid:'693915200923',
                data:[arr[n]]
              });
              this.setState({loading:false});
            }catch(e){
              console.error(e);
              Toast.fail(e.message);
              this.setState({loading:false});
            }
          }
        }
        n++;
      }
      this.setState({curFoodImgList:fin});
    
    }
  }
  fileImgUp = async(v)=>{
    let files = v.target.files || v.dataTransfer.files;
    if (!files.length) return false;
   
    let type = files[0].name; 
    type=type.split('.')
    let size = files[0].size; //文件的大小，判断图片的大小
    if (size > 3670016) {
      Toast.info('请选择3.5M以内的图片！',1);
      return false;
    }
    this.setState({
      loading:true
    });
    this.uploadFile(
      files[0],
      `http://kingofdinner.realsun.me:1201/api/AliyunOss/PutOneImageObject?bucketname=nutritiontower&srctype=${
        type[1]
      }`,
      'cloud'
    ).then(
      result => {
        let arr =this.state.curFoodImgList;
        arr.push({url:result,activated:true});
        this.setState({curFoodImgList:arr,loading:false})
      },
      err => {
        //图片上传异常！
        this.setState({ loading: false});
      }
    );
  }
  uploadFile = (file, url, mode) => {
    return new Promise((resolve, reject) => {
      let fd = new FormData();
      fd.append('file', file, file.name);
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.onload = () => {
        const data = JSON.parse(xhr.response);
        if (xhr.status === 200 && (data.error === 0 || data.error === '0')) {
          let imgUrl;
          if (mode === 'local') {
            imgUrl = data.httpfilename;
          } else if (mode === 'cloud') {
            imgUrl = data.data;
          }
          resolve(imgUrl);
        } else {
          reject(data);
        }
      };
      xhr.send(fd);
    });
  };
  getUserData=async()=>{
    this.setState({loading:true});
    try{
      //获取用户数据
      let res = await http().getRecordAndSubTables({
        resid:685988118358,
        subresid:'685125496091,685990220046',
        getsubresource: 1
      })
      let latestRecid = '';
      let _index=0;
      if(res.data.data[0][685125496091].length>0){
        latestRecid = res.data.data[0][685125496091][0].latestRecid;
        _index = res.data.data[0][685125496091][0].latestOrder;
      }
      //获取食物数据
      let res2 = await this.getFoods(_index);
      if(res.data.data.length>0){
        let rank = '?';
        let bonus = '0';
        if(res.data.data[0][685990220046].length>0){
          rank = res.data.data[0][685990220046][0].rankAll;
          bonus = res.data.data[0][685990220046][0].bonus;

        }
        let userData={
          imgUrl:res.data.data[0].imgUrl,
          rank,
          bonus
        }
       
        let n = 0;
        let foodList = res2.data.data;
        let nutritionList=[];
        let bol=false;
        while(n<foodList.length){
          if(foodList[n].recid==latestRecid){
            this.setState({currentFood:foodList[n]});
            bol=true;
            let c=0;
            while(c<mapping.length){
              if(foodList[n][mapping[c].nameEN]){
                nutritionList.push({
                  name:mapping[c].nameCN,
                  value:foodList[n][mapping[c].nameEN]
                })
              }
              c++;
            }
          }
          n++;
        }
        if(!bol){
          this.setState({currentFood:foodList[0]});
          let c=0;
            while(c<mapping.length){
              if(foodList[0][mapping[c].nameEN]){
                nutritionList.push({
                  name:mapping[c].nameCN,
                  value:foodList[0][mapping[c].nameEN]
                })
              }
              c++;
            }
        }
        this.setState({isWordsEnd:false});
        await this.getMarkRec(latestRecid);
        await this.getWords(latestRecid)
        this.setState({foodList,userData,nutritionList,totalFoods:res2.data.total});
      }else{
        Toast.fail('未找到用户，请重新登陆')
        this.history.props.push('/login')
      }
    this.setState({loading:false});

    }catch(e){
      console.error(e);
      if(e.message=='loginerror'){
        this.props.history.push('/login');
      }
      Toast.fail(e.message);
      this.setState({loading:false});
    }
  }
  //手接触屏幕
  handleTouchStart = (e) => {
    if(!this.state.showValue){

    this.startX = e.touches[0].clientX;
    }
  
};
  //手在屏幕上移动
  handleTouchMove = (e) => {
    if(!this.state.showValue){
      this.endX = e.touches[0].clientX;
      this.endY = e.touches[0].clientY;
      let v = Math.abs(this.startX - this.endX);
      if(v>50){
        v=50;
      }
      v = v*2;
      let endX=this.endX - 60;
      let endY=this.endY - 80;
      let h = window.innerHeight - 84;
      let w = window.innerWidth - 120;
      if(endX<0){
        endX=0;
      }
      if(endX>w){
        endX=w;
      }
      if(endY<0){
        endY=0;
      }
      if(endY>h){
        endY=h;
      }
      this.setState({
        showProcess:true,
        processValue:v,
        endX,
        endY
      })
    }
      
  };
  //手离开屏幕
  handleTouchEnd = (e) => {
    if(!this.state.showValue){

      // 获取滑动范围
      this.setState({processValue:0,showProcess:false,endX:0,endX:0});
      if(this.startX>-1 && this.endX>-1){
          let distance = Math.abs(this.startX - this.endX);
          if (distance > 50) {
              if (this.startX > this.endX) {
                  this.changeData();
              } else {
                  let {showIndex} = this.state
                  this.changeData('-');
              }
          }
      }
      this.startX=-1
      this.endX=-1
    }
  };
  getFoods=async(index)=>{
    let _index = index;
    _index = _index/10;
    _index= Math.floor(_index);
    try{
      let res = await http().getTable({
        resid:685105280229,
        pageIndex:_index,
        pageSize:10
      })
      return res
    }catch(e){
      console.error(e);
      Toast.fail(e.message);
      this.setState({loading:false});
    }
  }
  // 切换食材
  changeData=async(v)=>{
    let _index = this.state.currentFood.foodOrder;
    if( _index==1 && v=='-'){
      Toast.info('已经是第一个食材了',1);
      return false;
    }
    if(_index==this.state.totalFoods  && v!='-'){
      Toast.info('已经是最后一个食材了',1);
      return false;
    }
    let foodList = this.state.foodList;
    //是本地缓存的最后一个食物的场合，获取下面十个食物
    if(_index==foodList[foodList.length-1].foodOrder && v!='-'){
      this.setState({loading:true});
      let res = await this.getFoods(_index);
      foodList=foodList.concat(res.data.data);
      this.setState({foodList})
    }
    //是本地缓存的第一个食物，获取前面十个食物
    if(_index==foodList[0].foodOrder && v=='-'){
      this.setState({loading:true});
      let _indexM=_index-10;
      if(_indexM<0){
        _indexM=0;
      }
      let res = await this.getFoods(_indexM);
      foodList=res.data.data.concat(foodList);
      this.setState({foodList});
    }
    if(v=='-'){
      _index = _index - 1;
    }else{
      _index = _index + 1;
    }
    
    let n = 0;
    let latestRecid = ''
    let currentFood={}
    while(n<foodList.length){
      if(foodList[n].foodOrder==_index){
        currentFood=foodList[n];
        latestRecid=foodList[n].recid;
      }
      n++;
    }

    let nutritionList=[];
        n=0;
        while(n<foodList.length){
          if(foodList[n].recid==latestRecid){
            let c=0;
            while(c<mapping.length){
              if(foodList[n][mapping[c].nameEN]){
                nutritionList.push({
                  name:mapping[c].nameCN,
                  value:foodList[n][mapping[c].nameEN]
                })
              }
              c++;
            }
          }
          n++;
        }
    this.setState({wordsList:[],isWordsEnd:false});
    await this.getMarkRec(latestRecid);
    await this.getWords(latestRecid);
    this.setState({animate:false,nutritionList,loading:false,wordsIndex:0});
    let _this = this;
    let t = setTimeout(()=>{
      document.getElementById('cal').scrollTop = 0
      _this.setState({animate:true,currentFood});
      clearTimeout(t)
    },100)
  }
  submit=async(v)=>{
    if(v===false){
      if(this.state.recValue==='推荐'||this.state.recValue=='非常推荐'){
        Toast.fail('请先选择不推荐程度',1)
        return false
      }
    }else{
      if(this.state.recValue==='不推荐'||this.state.recValue=='非常不推荐'){
        Toast.fail('请先选择推荐程度',1)
        return false
      }
    }
    this.setState({loading:true});
    try{
      let obj={};
      let n = 0;
      let foodList = this.state.foodList
      //相同推荐类别的场合不改推荐总数。已推荐过修改推荐类别（比如推荐改成不推荐）的场合，现类别+1，原类别-1.未推荐过的场合，直接现类别+1。
      while(n<foodList.length){
        if(foodList[n].recid == this.state.currentFood.recid){
          if(v==false){
            if(this.state.curMarkRec.REC_ID){
              if(this.state.curMarkRec.notRecommend!='Y'){
                foodList[n].notGood=foodList[n].notGood+1;
                foodList[n].good=foodList[n].good-1;
              } 
            }else{
              foodList[n].notGood=foodList[n].notGood+1;
            }
          }else{
            if(this.state.curMarkRec.REC_ID){
              if(this.state.curMarkRec.notRecommend=='Y'){
                foodList[n].notGood=foodList[n].notGood-1;
                foodList[n].good=foodList[n].good+1;
              } 
            }else{
              foodList[n].good=foodList[n].good+1;
            }
          }
        }
        n++;
      }
      this.setState({foodList});
      if(this.state.curMarkRec.REC_ID){
        obj = this.state.curMarkRec;
      }
      if(v==false){
        obj.notRecommend='Y';
        obj.recommend='';
      }else{
        obj.recommend='Y';
        obj.notRecommend='';
      }
      obj.recValue=this.state.recValue;
      obj.words=this.state.words;
      obj.phone=localStorage.getItem('UserCode');
      obj.foodRecid=this.state.currentFood.recid;
      obj._state='editoradd';
      obj.citation=this.state.citation;
      obj._id=1;
      let sub=[];
      n=0;
      while(n<this.state.curFoodImgList.length){
        if(this.state.curFoodImgList[n].REC_ID){
          sub.push(
            {resid: '693915200923',
            maindata: {
              url:this.state.curFoodImgList[n].url,
              activated:'Y',
              REC_ID:this.state.curFoodImgList[n].REC_ID,
              evaluateRecid:this.state.curFoodImgList[n].evaluateRecid,
              _state: 'editoradd',
              _id: n+1
              }
             }
          )
        }else{
          sub.push(
            {resid: '693915200923',
            maindata: {
              url:this.state.curFoodImgList[n].url,
              activated:'Y',
              _state: 'editoradd',
              _id: n+1
              }
             }
          )
        }
        
        n++;
      }
      let res = await http().saveRecordAndSubTables({
        data: [
          {
            resid: '685105216300',
            maindata: obj,
            subdata:sub
          }
        ]
      });
      // let res = await http().addRecords({
      //   resid:685105216300,
      //   data:[obj],
      //   isEditOrAdd: 'true'
      // });
      this.setState({curMarkRec:res.data.data[0]});
      let resNew = await http().getRecordAndSubTables({
        resid:685988118358,
        subresid:'685990220046',
        getsubresource: 1
      })
      let latestRecid = '';
      if(resNew.data.data[0][685990220046].length>0){
         let rank = resNew.data.data[0][685990220046][0].rankAll;
          let bonus = resNew.data.data[0][685990220046][0].bonus;
        let userData={
          imgUrl:resNew.data.data[0].imgUrl,
          rank,
          bonus
        }
        this.setState({
          userData
        })
      }
      Toast.success('打标签成功！',1)
    this.setState({loading:false,showValue:false});
    this.changeData();

    }catch(e){
      console.error(e);
      Toast.fail(e.message);
      this.setState({loading:false,showValue:false});
    }
  }
  getMarkRec=async(id)=>{
    this.setState({loading:true,curMarkRec:{}});
    try{
      let res = await http().getRecordAndSubTables({
        resid:685105216300,
        subresid:'693915200923',
        cmswhere:`foodRecid = '${id}'`
      });
      if(res.data.data.length>0){
        if(res.data.subdata.data){
          if(res.data.subdata.data.length>0){
            this.setState({curFoodImgList:res.data.subdata.data});
          }else{
            this.setState({curFoodImgList:[]});
          }
        }
        this.setState({citation:res.data.data[0].citation||'',curMarkRec:res.data.data[0],recValue:res.data.data[0].recValue||'',words:res.data.data[0].words||''});
      }else{
        // this.setState({recValue:1});
      }
    }catch(e){
      console.error(e);
      Toast.fail(e.message);
      this.setState({loading:false});
    }
  }
  getWords=async(id,page)=>{
    if(!this.state.isWordsEnd){
      let npage = 0;
      if(page||page==0){
        npage=page;
        this.setState({loading:true});
        npage++;
      }
      try{
        let res = await http().getRecordAndSubTables({
          resid:'688123052655',
          subresid:'693765420257',
          cmswhere:`foodRecid = '${id}'`,
          getsubresource: 1,
          pageSize:10,
          pageIndex:npage
        });
        if(res.data.data.length>0){
          let arr =this.state.wordsList
          arr=arr.concat(res.data.data);
          this.setState({
            wordsList:arr
          });
        }
        if(this.state.wordsList.length>=res.data.total){
          this.setState({isWordsEnd:true});
        }
        if(page||page==0){
          if(res.data.data.length==0){
            this.setState({isWordsEnd:true});
          }
          this.setState({loading:false})
        }
      }catch(e){
        console.error(e);
        Toast.fail(e.message);
        this.setState({loading:false});
      }
    }
  }
   //手接触屏幕
   handleTouchStartWords = (e) => {
  }
 //手在屏幕上移动
 handleTouchMoveWords = (e) => {
 };
  //手离开屏幕
  handleTouchEndWords = (e) => {
    let t = document.getElementById('cal').scrollTop;
    let h = document.getElementById('cal').scrollHeight;
    let o = document.getElementById('cal').clientHeight;
    if(h==t+o){
      this.getWords(this.state.currentFood.REC_ID,this.state.wordsIndex);
    }
  };
  render() {
    return (
      <div className="lablist">
        {this.state.loading?<Loading/>:null}
        <div className='enlargeImg' style={this.state.curImgUrl?{display:'block'}:{display:'none'}} onClick={()=>{this.setState({enlarge:!this.state.enlarge});}}>{this.state.enlarge?'原尺寸':'适应屏幕'}</div>
        <Icon className='hideImg' style={this.state.curImgUrl?{display:'block'}:{display:'none'}} onClick={()=>{this.hideImg();}} type='cross'/>
        <div className="imgDetail"  style={this.state.curImgUrl?{transform:'scale(1)'}:{transform:'scale(0)'}}>
          <img  style={this.state.enlarge?{width:'100%',height:'auto'}:{}} src={this.state.curImgUrl}/>
          <div className="toclz" onClick={()=>{this.hideImg();}}></div>
        </div>
        <div className={this.state.showValue?'mask':'hidden'}>
          <div className='clz' onClick={
            ()=>{
              this.setState({
                showValue:false
              })
            }
          }>
          </div>
          <div className='modalContent'>
              <h3>推荐程度
              <Icon   onClick={()=>{
                this.setState({showValue:false});
              }} type='cross'style={{color:'#333',float:'right',verticalAlign:'middle',position:'absolute',top:'.5rem',right:'.5rem'}}/></h3>
              <ul>
                {
                   this.state.isNotRec?null:pingFen.map((item,key)=>{
                    return(
                      <li key={'_0'+key} className={this.state.recValue===item?'current':''} onClick={()=>{this.setState({recValue:item});}}>
                          {item}
                      </li>
                    )
                  })
                }
                 {
                   !this.state.isNotRec?null:pingFenB.map((item,key)=>{
                    return(
                      <li key={'_0'+key} className={this.state.recValue===item?'current':''} onClick={()=>{this.setState({recValue:item});}}>
                          {item}
                      </li>
                    )
                  })
                }
              </ul>
                {/* <Slider 
                value={this.state.recValue}
                step={1} 
                style={{width:'80%',marginLeft:'10%',marginTop:'1.5rem'}}
                min={1}
                max={10}
                onChange={(v)=>{this.setState({recValue:v})}}
                />
                <p>
                  ↑拖动滑块改变推荐数值
                </p> */}
              
              {/* <ul>
                {
                  reco.map(
                    (item)=>{
                      return(
                        <li className={this.state.recValue==item?'current':''} onClick={()=>{this.setState({
                          recValue:item
                        })}}>
                          {item}
                        </li>
                      )
                    }
                  )
                }
              </ul>
              <div className='hint'>
              <div>
                不太推荐
              </div>
              <div>
                |
              </div>
              <div>
                |
              </div> <div>
                |
              </div> <div>
                |
              </div> <div>
                |
              </div> <div>
                |
              </div>
              <div>
                |
              </div> <div>
                |
              </div>
              <div>
                十分推荐
              </div>
              
              </div> */}
              <div className='words'>
              <div>
                评语（选填,最多30字）：
              </div>
              <textarea maxLength={30} value={this.state.words} onChange={(v)=>{this.setState({words:v.target.value})}}/>
              <div style={{marginTop:'.5rem'}}>
                医学引用：
              </div>
              <div className="pics">
                    <input
                        id="ss"
                        name="ss"
                        type="file"
                        onChange={v => {
                          this.fileImgUp(v);
                        }}
                        accept="image"
                        style={{display:'none'}}
                      />
                      <div
                      onClick={
                        ()=>{
                          document.getElementById("ss").click();
                        }
                      }
                       
                      >
                        <p>+</p>
                        <p>点击选择图片</p>
                      </div>
                      {
                        this.state.curFoodImgList.map((item,key)=>{
                          return(
                          <>
                          <div
                            style={{
                              backgroundImage:'url('+item.url+')',
                              backgroundSize:'contain',
                              backgroundRepeat:'no-repeat',
                              backgroundPosition:'center'
                            }}
                            onClick={()=>{this.showImg(item.url);}}
                            key={'_img'+key}
                          >
                          </div>
                          <Icon className="clz" type='cross'
                            onClick={()=>{
                              Antalert("确认删除该图片？","", [
                                { text: "取消", onPress: () => {} },
                                {
                                  text: "确认",
                                  onPress: () =>  this.delImg(key)
                                }
                              ]);
                            }}
                            />
                          </>
                          )
                        })
                      }
                      
              </div>
              <div>
                引用说明：
              </div>
              <textarea maxLength={30} style={{marginBottom:'1.5rem'}} value={this.state.citation} onChange={(v)=>{this.setState({citation:v.target.value})}}/>
              
              </div>
              <div className='mainBtn'
            onClick={
              ()=>{
                if(this.state.isNotRec){
                  this.submit(false);
                }else{
                  this.submit();
                }
              }
            }
          >
            确定
          </div>
          </div>
          
         
        </div>
        <div 
        
        >
        <div className={this.state.showProcess?'processBar':'hidden'} style={{left:this.state.endX+'px',top:this.state.endY+'px'}}>
            <p>{this.startX > this.endX?(this.state.processValue==100?'√ 下一项 √':'> 下一项 >'):(this.state.processValue==100?'√ 上一项 √':'< 上一项 <')}</p>
            <div style={{width:this.state.processValue+'%',background:this.startX>this.endX?'#f759ab':'#36cfc9'}}></div>
        </div>
        <div className='header'>
         <div className='logo' onClick={()=>{
                    this.props.history.push('/');
                  }}>主页</div>
         <div className='userInfo'>
          <div className='prop'>
            <p className='rank'  onClick={
                    ()=>{
                      this.props.history.push('/rank?eventId=685108179250')
                    }
                  }>
              <i></i>{this.state.userData.rank}
              </p>
              <p className='bonus' onClick={
                    ()=>{
                      this.props.history.push('/bonusApp?eventId=685108179250')
                    }
                  }>
              <i></i>{this.state.userData.bonus}
              </p>
          </div>
          <div className='avatar' onClick={()=>{
                    this.props.history.push('/user');
                  }}
                  
                  style={this.state.userData.imgUrl?{backgroundImage:'url('+this.state.userData.imgUrl+')',backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize:'contain'}:{}}
                  ></div>
        </div>
         
        </div>
          <div className='focusArea'
         
          >
            <div className='titleLine'>
              <div className='foodName'>
                <span className={this.state.animate?'fadeIn':''}>
                  {this.state.currentFood.foodName}
                </span>
              </div>
              <div className='foodIndex' onClick={
                ()=>{
                  this.props.history.push('/bonus?eventId=685108179250')
                }
              }>
                <span className={this.state.animate?'fadeIn':''}>
                {this.state.currentFood.foodOrder}/{this.state.totalFoods}
                <i></i>
                </span>
              </div>
            </div>
          </div>
          <div className='banner'
             onTouchStart={this.handleTouchStart}
             onTouchMove={this.handleTouchMove}
             onTouchEnd={this.handleTouchEnd}
          >
            <div className='img'>
                <div style={{
                  backgroundImage:'url('+this.state.currentFood.imgUrl+')',
                  backgroundSize:'contain',
                  backgroundPosition:'center',
                  backgroundRepeat:'no-repeat',
                  backgroundColor:'#fff'
                }}
                className={this.state.animate?'shrink':''}
                >
                </div>
               
            </div>
            <div className={this.state.animate?'fadeIn hint':'hint'} onClick={()=>{this.changeData();}} style={this.state.currentFood.foodOrder==this.state.totalFoods?{display:'none'}:{}}>
            <p>
              向左滑动查看更多
            </p>
            <p>
              》
            </p>
            </div>
            <div className={this.state.animate?'fadeIn hint hint_left':'hint hint_left'} onClick={()=>{this.changeData('-');}} style={this.state.currentFood.foodOrder==1?{display:'none'}:{}}>
            <div>
              《
            </div>
            <div>
              向右滑动进行回溯
            </div>
            
            </div>
            
          </div>
          <div className={this.state.curMarkRec.notRecommend=='Y'?'notRecommend':(this.state.curMarkRec.recommend=='Y'?'fail':'')}
          onClick={
            ()=>{
            this.setState({showValue:true,isNotRec:true});

              // this.submit(false);
            }
          }
          >
          <div className={this.state.animate?'actionBarL enterL':'actionBarL'}>
            <div>
              <p style={this.state.recValue==='非常不推荐'?{marginTop:'.35rem'}:{}}>{
                this.state.recValue==='非常不推荐'?<>非常<br/>不推荐</>:'不推荐'
              }</p>
              {/* <small>{this.state.currentFood.notGood}</small> */}
            </div>
            <i></i>
          </div>

          </div>
          <div className={this.state.curMarkRec.recommend=='Y'?'recommend':(this.state.curMarkRec.notRecommend=='Y'?'fail':'')}>

          <div  onClick={()=>{
            this.setState({showValue:true,isNotRec:false});
          }} className={this.state.animate?'actionBarR enterR':'actionBarR'}>
            <i></i>
            <div>
              <p> {
                this.state.curMarkRec.recValue=='非常推荐'?
                '非常推荐'
                :'推荐'
              }</p>
             
            </div>
            </div>
          </div>
          <div className='nutritionList'
           onTouchEnd={this.handleTouchEndWords}
           onTouchMove={this.handleTouchMoveWords}
           onTouchStart={this.handleTouchStartWords}
          id={'cal'}
          >
            <dl className={this.state.animate?'fadeIn':''} style={!this.state.showAll?{height:'8.5rem'}:{height:'60%'}}>
              <dt>
                营养元素
                <span>每{this.state.currentFood.denominatorValue}{this.state.currentFood.denominatorUnit}</span>
              </dt>
              {
                this.state.nutritionList.map(
                  (item,key)=>{
                    return(
                      <dd key={key}>
                        <span>{item.name}</span>
                        <span>{item.value}{this.state.currentFood.numeratorUnit}</span>
                      </dd>
                    )
                  }
                )
              }
            </dl>
            <div className='divider' onClick={()=>{this.setState({showAll:!this.state.showAll})}}>
              <span style={this.state.showAll?{transform:'rotate(270deg)',top:'-.3rem'}:{transform:'rotate(90deg)'}}>》</span>{this.state.showAll?'收起营养元素':'展开营养元素'}
            </div>
            <ul 
               className={this.state.animate?'fadeIn':''}>
              {
                this.state.wordsList.length==0?<p className='noCom'>暂无评论</p>:null
              }
              {
                this.state.wordsList.map(
                  (item,key)=>{
                    return(
                       <li key={'words'+key}>
                        <div className='ava'
                          style={{
                            backgroundImage:'url('+item.avatar+')',
                            backgroundSize:'cover',
                            backgroundRepeat:'no-repeat',
                            backgroundPosition:'center'
                          }}
                        >
                        </div>
                        <span className='name'>
                          {item.peopleName}
                        </span>
                        <span className='time'>
                          {item.markTime}
                        </span>
                        <div className='fix'>
                        </div>
                        <p> 
                          {item.words}
                        </p>
                        <div className='citation'>
                        <h4>医学引用</h4>
                        <div className="img" style={item.citationImg>0?{display:'block'}:{display:'none'}}>
                          
                        {
                          item[693765420257].length>0?
                          item[693765420257].map(
                            (item2,key2)=>{return(
                                 <div
                                    key={item.REC_ID+'_'+key2}
                                    onClick={()=>{this.showImg(item2.url);}}
                                    style={{
                                      backgroundImage:'url('+item2.url+')',
                                      backgroundSize:'contain',
                                      backgroundRepeat:'no-repeat',
                                      backgroundPosition:'center',
                                      backgroundColor:'#f5f5f5'
                                    }}
                                  >

                                  </div>
                            )}
                          )
                          :null
                        }
                        </div>
                        <div className='words' style={item.citation?{display:'block'}:{display:'none'}}>
                        {item.citation}
                       </div>
                       </div>
                       
                      </li>
                    )
                  }
                )
              }
            </ul>
          </div>
          </div>
      </div>
    );
  }
}

export default Lablist;
